import { useSelector } from 'react-redux';

import {
  selectFinalState,
  selectPaymentResultMessage,
} from '@cashier/cashier-data-access';
import { FinalStates, ResultMessage } from '@cashier/cashier-model';

export interface UseStatusBlock {
  finalState: FinalStates;
  message: ResultMessage | null;
}

export const useStatusBlock = (): UseStatusBlock => {
  const finalState = useSelector(selectFinalState);
  const message = useSelector(selectPaymentResultMessage);

  return {
    finalState,
    message,
  };
};
